import { makeAxiosRequest } from 'utils/apiMethods';

interface WidgetApi {
  fetchWidgets: (data: any) => Promise<any>;
  fetchWidgetDetails: any;
  saveWidgetPlacement: (data: any) => Promise<any>;
  fetchDeviceReading: any;
}

const widgetApi: WidgetApi = {
  fetchWidgets: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/widgets/`, {
    method: 'get',
  }),
  fetchWidgetDetails: (id: string) =>
    makeAxiosRequest(`${process.env.REACT_APP_API_URL}/widgets/${id}`, {
      method: 'get',
    }),
  saveWidgetPlacement: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/widgets/placement`, {
    method: 'post',
  }),
  fetchDeviceReading: (id: string) =>
    makeAxiosRequest(`${process.env.REACT_APP_API_URL}/devices/readings/${id}`, {
      method: 'get',
    }),
};

export default widgetApi;
